<template>
    <div>
        <div class="row mb-3">
            <div class="col">
                <label>{{ choiceLabel }}</label>
                <x-select id="selectAttribute"
                          name="selectAttribute"
                          class="selectAttribute"
                          v-model="attribute"
                          @selected="$_attribuutSelected"
                          :options="availableLabels"
                          :simpleMode="true">
                </x-select>
                <b-button @click="$_addAttribute()"
                          variant="primary"
                          class="align-items-center"
                          :disabled="addButtonDisabled">
                    {{ $t('btnAddLabel') }}
                    <span class="fas fa-check"></span>
                </b-button>
                <div class="form-inline style-item mt-3">
                <label>{{ exampleLabel }}</label>
                </div>
                <div class="example border form-inline style-item" :style="textStyle">
                    {{ $_labelExample() }}
                </div>
            </div>
            <div class="col" v-if="hasTextAttribute">
                <text-properties
                    :themeStyle="style"
                    :id="`textPropertiesal${name}`"
                    :name="`textPropertiesal`">>
                </text-properties>
            </div>
        </div>
        <div class="table-sticky-header-container">
            <div>
                <table v-if="hasTextAttribute"
                        id="advancedLabels"
                        class="table table-striped table-responsive table-bordered">
                    <!-- SonarQube staat er op dat een <caption> wordt toegevoegd -->
                    <caption v-if="false">
                        Advanced Labels
                    </caption>
                    <thead>
                        <!-- Checkboxes in header are not draggable -->
                        <tr>
                            <th>{{ $t('changeLayerOrder') }}</th>
                            <th>{{ $t('labelSeparator') }}</th>
                            <th>{{ nameLabel }}</th>
                            <th class="showLabel">
                                {{ $t('labelShowLabel') }}
                            </th>
                            <th>{{ $t('labelLabel') }}</th>
                            <th>{{ removeLabel }}</th>
                        </tr>
                    </thead>
                    <v-draggable tag="tbody"
                                    handle=".fa-arrows-alt"
                                    v-model="informationAttributes"
                                    @end="$_updateOrderColumn">
                        <tr v-for="item in informationAttributes"
                            :key="item.name"
                            class="tablerow"
                            v-show="showTableRow(item)">
                            <td class="order-column">
                                <div>
                                    <em class="fa fa-arrows-alt"></em>
                                    <base-input type="text"
                                                :id="`${item.id}_order`"
                                                v-model="item.textAttributeOrder"
                                                extendedClass="order-input"
                                                width="50px">
                                    </base-input>
                                </div>
                            </td>
                            <td>
                                <x-select :id="`${item.id}_separator`"
                                            v-model="item.textAttributeSeparator"
                                            :options="separatorOptions"
                                            :simpleMode="true"
                                            :showDefaultOption="false">
                                </x-select>
                            </td>
                            <td class="align-middle">
                                <span>
                                    {{
                                    `${valueName(item)} (alias: ${
                                        item.alias
                                    })`
                                    }}
                                </span>
                            </td>
                            <td class="text-center align-middle">
                                <x-checkbox :id="`${item.id}_showLabel`"
                                            :name="`${item.id}_showLabel`"
                                            :state="null"
                                            :plainMode="true"
                                            v-model="item.textAttributeShowLabel"
                                            :expandClickArea="true">
                                </x-checkbox>
                            </td>
                            <td>
                                <base-input type="text"
                                            :id="`${item.id}_label`"
                                            v-model="item.textAttributeLabel"
                                            :extendedStyle="'width: auto'">
                                </base-input>
                            </td>
                            <td class="text-center align-middle">
                                <b-button v-bind:id="`${item.id}_removeAttribute`"
                                            v-bind:name="`${item.id}_removeAttribute`"
                                            @click="$_removeAttribute(item)">
                                    <span class="fa fa-trash-alt"></span>
                                </b-button>
                            </td>
                        </tr>
                    </v-draggable>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import XCheckbox from '../../BaseComponents/x-checkbox.vue';
    import XSelect from '../../BaseComponents/x-select.vue';
    import BaseInput from '../../BaseComponents/base-input.vue';
    import modalMixin from '../../Mixins/ModalMixin.vue';
    import TextProperties from '../StylingOptions/TextProperties.vue';
    import { convertToValueTextPair } from '../../../services/utilities';
    import { orderBy } from 'lodash';
    import { GetTextValue } from '../../../services/map/feature/styles';
    import OlFeature from 'ol/Feature';
    import { LABEL_SEPARATOR_OPTIONS } from '../../../constants';

    export default {
        name: 'AdvancedLabelsTab',
        mixins: [modalMixin],

        components: {
            'v-draggable': draggable,
            'x-checkbox': XCheckbox,
            'x-select': XSelect,
            'base-input': BaseInput,
            'text-properties': TextProperties
        },

        props: {
            themelayer: { type: Object, required: false, default: null },
            feedback: { type: Object, required: false, default: null }
        },

        data() {
            return {
                separatorOptions: LABEL_SEPARATOR_OPTIONS,
                attribute: 0,
                style: (this.themelayer) ? this.themelayer.styles[0] : this.feedback.styles[0],
                informationAttributes: null
            };
        },

        created() {
            // copy all infomation about attributes to local var
            this.$_onClickChangeOrder();
            this.$_updateOrderColumn();
        },

        computed: {
            hasTextAttribute() {
                return this.informationAttributes.some((i) => i.isTextAttribute);
            },
            showTableRow() {
                return (item) => {
                    return item.isTextAttribute;
                };
            },
            availableLabels() {
                let attributes = null;
                if (this.informationAttributes != null) {
                    if (this.themelayer) {
                        attributes = orderBy(
                            this.informationAttributes.filter(
                                (i) => !i.isTextAttribute
                            ),
                            [(i) => i.attribute.toLowerCase()]
                        );
                    } else {
                        attributes = orderBy(
                            this.informationAttributes.filter(
                                (i) => !i.isTextAttribute
                            ),
                            [(i) => i.name.toLowerCase()]
                        );
                    }
                    if (attributes != null && attributes.length > 0) {
                        return convertToValueTextPair(
                            attributes,
                            'id',
                            this.attributeName
                        );
                    }
                }
                return [];
            },
            addButtonDisabled() {
                return (
                    this.attribute === 0 ||
                    this.attribute === null ||
                    this.attribute === undefined
                );
            },
            textStyle() {
                if (this.style === null || this.style === undefined) {
                    return null;
                }
                const color = `color: ${this.style.textFillColorDefault};`;
                const sc = this.style.textStrokeColorDefault;
                const fontFamily = `font-family: ${this.style.textFontDefault};`;
                const fontSize = `font-size : ${this.style.textFontSizeDefault}px;`;
                let sw = this.style.textStrokeWidthDefault;
                const shadow = `text-shadow: 0 0 ${sw}px ${sc}, 0 0 ${sw}px ${sc}, 0 0 ${sw}px ${sc}, 0 0 ${sw}px ${sc};`;
                return `${color} ${fontFamily} ${fontSize} ${shadow}`;
            },
            exampleLabel() {
                return `${this.$t('styling.preview')}${this.$t(
                    'labelLabel'
                ).toLowerCase()}`;
            },
            choiceLabel() {
                return this.themelayer
                    ? this.$t('labelAddLabel')
                    : this.$t('labelAddInputfield');
            },
            nameLabel() {
                return this.themelayer
                    ? this.$t('labelAttributeName')
                    : this.$t('labelInputFieldName');
            },
            removeLabel() {
                return this.themelayer
                    ? this.$t('labelRemoveLabel')
                    : this.$t('labelRemoveInputfield');
            },
            valueName() {
                return (item) => {
                    return this.themelayer ? item.attribute : item.name;
                };
            },
            attributeName() {
                return this.themelayer ? 'attribute' : 'name';
            },
            textStrokeColor: {
                get() {
                    return this.selectedStrokeColor;
                },
                set(input) {
                    this.selectedStrokeColor = input;
                    this.$emit('update:strokeColor', this.selectedStrokeColor);
                }
            },
            lineFillColor: {
                get() {
                    return this.selectedFillColor;
                },
                set(input) {
                    this.selectedFillColor = input;
                    this.$emit('update:fillColor', this.selectedFillColor);
                }
            },
            name() {
                return this.themelayer ? this.themelayer.name : this.feedback.name;
            }
        },

        methods: {
            /**
             * Removes given attribute as a label
             * @param attribute
             */
            $_removeAttribute(attribute) {
                const data = {
                    message: this.$t('labelDeleteConfirmation', [
                        this.themelayer ? attribute.attribute : attribute.name
                    ])
                };
                this.msgBoxConfirm(data).then((confirm) => {
                    if (confirm) {
                        attribute.isTextAttribute = false;
                        this.$_updateOrderColumn();
                    }
                });
            },

            $_updateOrderColumn() {
                if (this.informationAttributes != null) {
                    this.informationAttributes
                        .filter((i) => i.isTextAttribute)
                        .forEach((item, index) => {
                            item.textAttributeOrder = index + 1;
                        });
                }
            },

            $_onClickChangeOrder() {
                this.informationAttributes?.sort(
                    (a, b) => a.textAttributeOrder - b.textAttributeOrder
                );
            },
            $_attribuutSelected(event) {
                this.attribute = event ?? 0;
            },
            $_addAttribute() {
                let informationAttribute = this.informationAttributes?.find(
                    (i) => i.id === this.attribute
                );
                informationAttribute.isTextAttribute = true;
                this.attribute = null;
                this.$_updateOrderColumn();
            },
            $_labelExample() {
                let properties = {};
                if (this.informationAttributes != null) {
                    if (this.themelayer) {
                        this.informationAttributes
                            .filter((i) => i.isTextAttribute)
                            .forEach((item) => {
                                properties[item.id.toString()] =
                                    item.attribute.toLowerCase();
                            });
                    } else if (this.feedback) {
                        this.informationAttributes
                            .filter((i) => i.isTextAttribute)
                            .forEach((item) => {
                                properties[item.id.toString()] =
                                    item.name.toLowerCase();
                            });
                    }
                }
                const feature = new OlFeature();
                feature.setProperties(properties);

                return GetTextValue(
                    feature,
                    this.informationAttributes.filter((i) => i.isTextAttribute)
                );
            },
            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            }
        },

        watch: {
            themelayer: {
                handler: function (layer) {
                    if (this.themelayer) {
                        this.informationAttributes = [
                            ...this.themelayer.informationAttributes
                        ];
                    }
                },
                immediate: true
            },
            feedback: {
                handler: function (feedback) {
                    if (this.feedback) {
                        this.informationAttributes = [
                            ...this.feedback.feedbackFields
                        ];
                    }
                },
                immediate: true
            }
        }
    };
</script>

<style lang="scss">
#informationoverview {
    & div .order-input {
        width: 60px;
    }
    & div .sort-select {
        width: 110px;
    }
    .form-group {
        margin-bottom: 0px;
    }
}
</style>

<style scoped lang="scss">
.table-sticky-header-container {
    height: 750px;
    margin-bottom: 25px;
    border-top: 1px solid #dee2e6;

    > div {
        height: 100%;
        overflow: auto;

        > table {
            display: initial;
            border: 0;

            th {
                position: sticky;
                top: 0;
                z-index: 2;
                background-color: white;

                &:first-child {
                    border-left: 1px solid #dee2e6;
                }
            }
        }
    }
}

.fa-arrows-alt:hover {
    cursor: move;
}

.order-column {
    & div {
        display: flex;
        align-items: center;

        & em {
            padding-right: 0.4rem;
        }
    }
}

#informationoverview.table-bordered {
    td {
        vertical-align: middle;
    }
    // Following classes together remove the vertical line between the last two cells in each row
    td:nth-child(11) {
        border-right-width: 0px;
    }

    td:last-child {
        border-left-width: 0px;
    }
}

.example {
    white-space: pre-line;
    padding: 3px;
    text-transform: capitalize;
    font-weight: bold;
}
.showLabel {
    width: 100px;
}
.selectAttribute {
    width: 250px;
}
</style>
